import React from "react";
import { Icon } from "@iconify/react";
import Featurelist from "../home/Feature/FeatureProductlist/Featurelist";
export default function Search({
	len,
	setSearch,
	search,
	filteredData,
	searchbtn,
	searchRef,
	setSearchBtn,
}) {
	function handleClose() {
		setSearch("");
		setSearchBtn(false);
	}
	return (
		<>
			<div
				ref={searchRef}
				className={`fixed top-0 left-0 flex flex-col justify-between items-center z-[10000] w-full transition-transform duration-500 ease-in-out 
  ${len > 5 ? "h-screen" : "max-h-fit"} 
  ${
		searchbtn
			? "translate-y-0"
			: search.length === 0
			? "-translate-y-[200px]"
			: "-translate-y-full"
	} 
  overflow-y-auto shadow-lg`}>
				<div
					className={`flex flex-col shadow-lg justify-between items-center w-full ${
						len > 5 ? "h-screen bg-white-400" : "h-fit"
					} bg-white lg:px-16 md:px-10 px-4 lg:py-12 md:py-12 pb-5 myscrol overflow-y-auto`}>
					<div className="flex flex-col md:flex-row lg:flex-row justify-between items-center w-full">
						<div className="relative md:w-fit lg:w-fit w-full   ">
							<div className="my-2 w-fit md:block hidden">
								<h2 className=" relative  myclass  text-5xl font-medium  tracking-tight text-gray-800 leading-tight">
									Monsini
									<span
										className="absolute  font-poppins leading-3 tracking-[0.01px]
  bottom-0  right-0 font-bold text-[10px] text-[#ff2e38]  ">
										PROUDLY CANADIAN
									</span>
								</h2>
							</div>

							<div className="flex justify-between   items-center lg:hidden md:hidden w-full mt-2 mb-6">
								<div className="my-2 w-fit">
									<h2 className=" relative  myclass  text-5xl font-medium  tracking-tight text-gray-800 leading-tight">
										Monsini
										<span
											className="absolute  font-poppins leading-3 tracking-[0.01px]
  bottom-0  right-0 font-bold text-[10px] text-[#ff2e38]  ">
											PROUDLY CANADIAN
										</span>
									</h2>
								</div>
								<button onClick={() => handleClose()}>
									<Icon
										icon="akar-icons:cross"
										width="1.6rem"
										height="1.6rem"
										style={{ color: "black" }}
									/>
								</button>
							</div>
						</div>

						<div className="w-full flex justify-center relative">
							<input
								type="text"
								className="lg:w-1/2 md:w-3/4 sm:w-full w-full px-3 py-3 focus:outline-black border-2 border-black border-opacity-30 rounded-md font-Jost-Regular"
								placeholder="Search here ....."
								value={search}
								onChange={(e) => setSearch(e.target.value)}
							/>
							<button className="absolute top-[10px] lg:right-[26%] md:right-[15%] sm:right-[2%] right-[2%] z-10">
								<Icon
									icon="bitcoin-icons:search-filled"
									width="2rem"
									height="2rem"
									style={{ color: "black" }}
								/>
							</button>
						</div>
						<div className="md:flex lg:flex hidden  ">
							<button onClick={() => setSearchBtn(false)}>
								<Icon
									icon="akar-icons:cross"
									width="1.6rem"
									height="1.6rem"
									style={{ color: "black" }}
								/>
							</button>
						</div>
					</div>
					<div className="w-full mt-5">
						{search.length > 0 ? (
							filteredData.length > 0 ? (
								<ul
									data-aos="fade-right"
									data-aos-duration="300"
									className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 mt-20 mb-16 px-4 lg:ps-16 lg:pe-16 md:ps-10 md:pe-10 overflow-x-hidden">
									{filteredData.map((item) => (
										<Featurelist key={item.id} data={item} />
									))}
								</ul>
							) : (
								<div className="text-center mt-5">
									<p>No results found.</p>
								</div>
							)
						) : null}
					</div>
				</div>
			</div>
		</>
	);
}
